import { useEffect } from "react";
import { SelectPreparadorCatalog } from "./select/SelectPreparadorCatalog";
import { SelectMonths } from "./select/SelectMonths";
import { SelectModalityNewSer } from "./select/SelectModalityNewSer";
import { SelectUnspscID } from "../admin/configuracion/UnspscID/SelectUnspscID";
import { SelectProjectID } from "../admin/configuracion/ProjectID/SelectProjectID";
import { InputMoney } from "../theme/Input/InputMoney";
import { IDAdquisitionProject } from "../erp/AdquisitionProject/AdquisitionProjectSelect";
import { ITEM_PREPARADOR } from "../Constants";
import { _Project } from "../../core/services/dataBean/EntityCatalogVdos";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

interface Props {
    beanItem: any;
    setBeanItem: (bean: any) => void;
    rol?: number;
    token?: number;
    ListaTypes?: any[];
    missingFields?: any[];
}
//formulario unico para editar necesidades 
export const AdquisitionItemForm = ({
    beanItem,
    setBeanItem,
    rol,
    token,
    ListaTypes,
    missingFields = []
}: Props) => {
    const project = useDataBean(_Project);

    useEffect(() => {
        if (beanItem.IDProject && typeof beanItem.IDProject === "number") {
            project.instance.getProjectRender(null, null, { IDProject: beanItem.IDProject, State: 1 }).then(
                (resp: any) => {
                    if (resp && resp.List && resp.List.length > 0) {
                        project.setBean(resp.List[0].DataBeanProperties);
                    } else {
                        project.setBean({});
                    }
                }
            ).catch((err: any) => {
                toast.error("No se pudo cargar la informacion del proyecto");
                project.setBean({});
            });
        } else {
            project.setBean({});
        }
    }, [beanItem.IDProject]);

    const hasError = (field: string) => (missingFields.includes(field) ? "has-error" : "");

    return (
        <div className="row">
            <div className="col-md-6">
                <label>Código</label>
                <input
                    type="text"
                    className="form-control"
                    value={beanItem.CodeItem ?? ""}
                    onChange={(e) => {
                        setBeanItem({ ...beanItem, CodeItem: e.target.value });
                    }}
                />
            </div>

            {ListaTypes && ListaTypes.length > 0 && (
                <div className="col-md-6">
                    <label className={hasError("TypeManagment")}>Tipo de Necesidad</label>
                    <select
                        name="type"
                        className="form-select"
                        value={beanItem.TypeManagment ?? ""}
                        onChange={(e) => {
                            setBeanItem({ ...beanItem, TypeManagment: parseInt(e.target.value) });
                        }}
                    >
                        {ListaTypes.map((item: any, idx: number) => {
                            return (
                                <option key={idx} value={item.DataBeanProperties.Value}>
                                    {item.DataBeanProperties.Property}
                                </option>
                            );
                        })}
                    </select>
                </div>
            )}

            {beanItem.TypeManagment === 101 && (
                <>
                    <div className="col-md-6">
                        <label className={hasError("IDProject")}>Proyecto</label>
                        <IDAdquisitionProject
                            label=" "
                            idSelector={beanItem.IDProject}
                            onChange={(e: any) => {
                                setBeanItem({ ...beanItem, IDProject: e });
                            }}
                        />
                    </div>
                    {beanItem.IDProject && (
                        <div className="col-md-6">
                            <label>Valor disponible del proyecto</label>
                            <input
                                type="text"
                                value={
                                    project.bean?.Disponible != null
                                        ? new Intl.NumberFormat("es-CO", {
                                              style: "currency",
                                              currency: "COP",
                                              maximumFractionDigits: 2
                                          }).format(project.bean.Disponible)
                                        : ""
                                }
                                readOnly
                                className="form-control"
                            />
                        </div>
                    )}
                </>
            )}

            {rol !== ITEM_PREPARADOR && (
                <div className="col-md-6">
                    <SelectPreparadorCatalog
                        key={token}
                        idAdquisitionPlanFunctionalID={beanItem.IDAdquisitionPlanFunctionalID}
                        idSelector={beanItem.IDFunctionalIDPreparer != null ? beanItem.IDFunctionalIDPreparer : 0}
                        onChange={(id: number) => {
                            setBeanItem({ ...beanItem, IDFunctionalIDPreparer: id });
                        }}
                    />
                </div>
            )}

            <div className="col-md-6">
                <label className={hasError("TotalValue")}>Valor Estimado</label>
                <InputMoney
                    _label=" "
                    readonly={
                        beanItem.IDAdquisitionItem >= 0 &&
                        (beanItem.PhaseState === 2 || [12, 42].includes(beanItem.PreparationState))
                    }
                    _value={beanItem.TotalValue}
                    onChange={(e: any) => {
                        setBeanItem({ ...beanItem, TotalValue: e });
                    }}
                />
            </div>

            <div className="col-md-6">
                <label className={hasError("ExecutionMonth")}>Mes</label>
                <SelectMonths
                    label=" "
                    idSelector={beanItem.ExecutionMonth}
                    onChange={(e: number) => {
                        setBeanItem({ ...beanItem, ExecutionMonth: e });
                    }}
                />
            </div>

            <div className="col-md-6">
                <label>Meses Estimados</label>
                <input
                    type="number"
                    className="form-control"
                    value={beanItem.EstimatedMonths ?? ""}
                    onChange={(e) => {
                        setBeanItem({ ...beanItem, EstimatedMonths: e.target.value });
                    }}
                />
            </div>

            <div className="col-md-6">
                <SelectModalityNewSer
                    idSelector={beanItem.IDHiringModality}
                    onChange={(e: any) => {
                        setBeanItem({ ...beanItem, IDHiringModality: e });
                    }}
                />
            </div>

            <div className="col-md-6">
                <SelectUnspscID
                    label="Código Principal"
                    renderValue=""
                    idln={beanItem.IDLnUnspscItem}
                    onChange={(e: any) => {
                        setBeanItem({ ...beanItem, IDLnUnspscItem: e.IDLn });
                    }}
                />
            </div>

            <div className="col-md-12">
                <SelectProjectID
                    edit={false}
                    projectIDLn={beanItem.IDLnProjectID}
                    onChange={(e: any) => {
                        setBeanItem({ ...beanItem, IDLnProjectID: e.IDLn });
                    }}
                />
            </div>

            <div className="col-md-12">
                <label className={hasError("Justification")}>Justificación</label>
                <textarea
                    className="form-control"
                    placeholder="Incluya los aspectos legales, procedimentales, funcionales que sustentan la solicitud"
                    value={beanItem.Justification != null ? beanItem.Justification : ""}
                    onChange={(e) => {
                        setBeanItem({ ...beanItem, Justification: e.target.value });
                    }}
                />
            </div>

            <div className="col-md-12">
                <label className={hasError("Description")}>Objeto de la Necesidad</label>
                <textarea
                    className="form-control"
                    value={beanItem.Description ?? ""}
                    onChange={(e) => {
                        setBeanItem({ ...beanItem, Description: e.target.value });
                    }}
                />
            </div>
        </div>
    );
};
